import { render, staticRenderFns } from "./DoctorSetupBankDetail.vue?vue&type=template&id=365e907e&"
import script from "./DoctorSetupBankDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorSetupBankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports